import { render, staticRenderFns } from "./DrawingPicture.vue?vue&type=template&id=4b39bd1c&scoped=true"
import script from "./DrawingPicture.vue?vue&type=script&lang=js"
export * from "./DrawingPicture.vue?vue&type=script&lang=js"
import style0 from "./DrawingPicture.vue?vue&type=style&index=0&id=4b39bd1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b39bd1c",
  null
  
)

export default component.exports